<div *ngIf="show" class="app-Notification">
  <div class="app-Notification-content">
    <div class="app-Notification-message">{{ message }}</div>
  </div>
</div>
